var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reviews"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29995",
    "data-name": "Rectangle 29995",
    width: 16,
    height: 16,
    transform: "translate(26 345)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_838",
    "data-name": "Mask Group 838",
    transform: "translate(-26 -345)",
    clipPath: "url(#reviews)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-06-16T121354.091",
    "data-name": "svgexport-6 - 2022-06-16T121354.091",
    transform: "translate(26 345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15932",
    "data-name": "Group 15932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27511",
    "data-name": "Path 27511",
    d: "M15.048,2.334H4.771a.318.318,0,0,0,0,.635H15.048a.318.318,0,0,1,.317.317v7.5a.318.318,0,0,1-.317.317H9.491a.317.317,0,0,0-.249.121l-1.28,1.622L6.6,11.218A.317.317,0,0,0,6.36,11.1H.952a.318.318,0,0,1-.317-.317v-7.5a.318.318,0,0,1,.317-.317H2.16a.318.318,0,0,0,0-.635H.952A.953.953,0,0,0,0,3.286v7.5a.953.953,0,0,0,.952.952H6.211l1.513,1.815a.319.319,0,0,0,.493-.007l1.427-1.808h5.4A.953.953,0,0,0,16,10.786v-7.5a.953.953,0,0,0-.952-.952Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27512",
    "data-name": "Path 27512",
    d: "M1.758,6.417a.317.317,0,0,0,.057.3l.618.746-.061.967c-.048.757,1.089-.047,1.334-.042s1.382.791,1.334.042l-.061-.967L5.6,6.718a.322.322,0,0,0-.166-.51l-.938-.24-.519-.818a.322.322,0,0,0-.536,0l-.519.818-.938.24a.317.317,0,0,0-.223.209ZM3.2,6.551c.235-.06.389-.453.507-.639.116.183.275.58.507.639l.575.147-.379.457a.317.317,0,0,0-.072.223l.038.593-.552-.219a.318.318,0,0,0-.234,0l-.552.219.038-.593A.317.317,0,0,0,3,7.156L2.623,6.7Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27513",
    "data-name": "Path 27513",
    d: "M9.917,6.417a.317.317,0,0,0-.223-.209l-.938-.24-.519-.818a.322.322,0,0,0-.536,0l-.519.818-.938.24a.317.317,0,0,0-.166.51l.618.746-.061.967c-.048.757,1.089-.047,1.334-.042S9.35,9.18,9.3,8.431l-.061-.967.618-.746a.317.317,0,0,0,.057-.3Zm-1.245.739a.317.317,0,0,0-.072.223l.038.593a2.107,2.107,0,0,0-.669-.241,2.116,2.116,0,0,0-.669.241l.038-.593a.317.317,0,0,0-.072-.223L6.886,6.7l.575-.147c.235-.06.389-.453.507-.639.116.183.275.58.507.639l.575.147Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27514",
    "data-name": "Path 27514",
    d: "M14.179,6.417a.317.317,0,0,0-.223-.209l-.938-.24L12.5,5.149a.322.322,0,0,0-.536,0l-.519.818-.938.24a.322.322,0,0,0-.166.51l.618.746-.061.967c-.048.757,1.088-.047,1.334-.042s1.382.791,1.334.042L13.5,7.464l.618-.746a.317.317,0,0,0,.057-.3Zm-1.245.739a.317.317,0,0,0-.072.223l.038.593-.552-.219a.318.318,0,0,0-.234,0l-.552.219.038-.593a.317.317,0,0,0-.072-.223L11.148,6.7l.575-.147c.235-.06.389-.453.507-.639.116.183.275.58.507.639l.575.147Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27515",
    "data-name": "Path 27515",
    d: "M3.3,2.915a.317.317,0,1,0-.12-.378A.319.319,0,0,0,3.3,2.915Z",
    fill: "#8391a2",
    stroke: "#8391a2",
    strokeWidth: 0.1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.74f56449f1009190880ad6f43155b7d9.svg";
export { ForwardRef as ReactComponent };